import api from "../api/api";
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const maquinaService = {


  async imprimitEtiqueta(maquina) {
    try {
      // Converte o valor de 'maquina' para inteiro
      const maquinaId = parseInt(maquina, 10);

      // Verifica se o valor convertido é um número válido
      if (isNaN(maquinaId)) {
        throw new Error("O valor fornecido para 'maquina' não é um número válido.");
      }

      const url = `${BASE_URL}/maquina/${maquinaId}/imprimir-etiqueta`;

      // Faz a requisição
      const response = await api.post(
        url,
        { maquina: maquinaId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        return response.data; // Retorna os dados diretamente
      } else {
        throw new Error("Erro ao adicionar máquina à fila.");
      }
    } catch (error) {
      handleError(error, "Erro ao adicionar máquina à fila.");
    }
  },


  obterTodos: async (params) => {
    try {
      const url = `${BASE_URL}/maquinas-lista-completa`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter maquinas:", error);
      throw new Error("Erro ao obter maquinas.");
    }
  },



  obterPorId: async (id) => {
    try {
      const url = `${BASE_URL}/maquinas/${id}/ficha-completa`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao obter maquina por id:", error);
      throw new Error("Erro ao obter maquina por id.");
    }
  }

  // ... Outros métodos, como criar, atualizar, deletar, etc., também devem seguir essa estrutura.
};
